<template>
  <div>
    <div v-if="this.$vuetify.breakpoint.smAndDown" class="wrapper">
      <div class="wrapper-inner">
        <!-- <v-layout fill-height column> -->
        <br />
        <br />
        <v-flex xs12>
          <p class="welcome" :style="{ color: mainColor }">
            Welcome
            <br />
            {{ msg }}<br />and<br />Local Public Body Employees!
          </p>
        </v-flex>
        <br />
        <br />
        <v-flex xs12>
          <v-img
            :src="require('@/assets/umbrella-family.png')"
            height="350"
            contain
            aspect-ratio="1.7"
          ></v-img>
        </v-flex>
        <br />
        <br />
        <br />
        <v-flex xs12 class="addPadding">
          <p class="welcomeText">
            The Employee Services Division of Globe Life is pleased to offer you
            a portfolio of insurance products to supplement your employer
            benefits.
          </p>

          <!-- <p class="welcomeText">
            The State of New Mexico, General Services Department, is pleased to announce their partnership with the Employee Services Division of Globe Life for the offering of voluntary life and cancer coverage insurance.
            <br />
            <br />You will find that Globe Life offers unique products at competitive rates. Please review all the offerings to help protect your family’s future.
          </p>-->
        </v-flex>
        <!-- </v-layout> -->
        <br /><br /><br /><br /><br />
        <v-flex xs12 class="addPadding">
          This is a solicitation for insurance. Policies and benefits may vary
          by state and product. These policies have some limitations and
          exclusions.
        </v-flex>
      </div>
    </div>
    <div v-else>
      <br />
      <br />
      <br />
      <v-layout row wrap>
        <v-flex xs6 class="pr-3">
          <v-img
            :src="require('@/assets/umbrella-family.png')"
            height="500"
            aspect-ratio="1.7"
            contain
          ></v-img>
        </v-flex>
        <v-flex xs5>
          <v-layout column justify-center fill-height>
            <p class="welcome" :style="{ color: mainColor }">
              Welcome
              <br />
              {{ msg }}<br />and<br />Local Public Body Employees!
            </p>
            <br />
            <p class="welcomeText">
              The Employee Services Division of Globe Life is pleased to offer
              you a portfolio of insurance products to supplement your employer
              benefits.
            </p>
            <!-- <v-card style="padding:20px;">
              <p class="welcomeText">
                The State of New Mexico, General Services Department, is pleased to announce their partnership with the Employee Services Division of Globe Life for the offering of voluntary life and cancer coverage insurance.
                <br />
                <br />You will find that Globe Life offers unique products at competitive rates. Please review all the offerings to help protect your family’s future.
              </p>
            </v-card>-->
          </v-layout>
        </v-flex>
      </v-layout>
      <br /><br /><br /><br /><br />
      This is a solicitation for insurance. Policies and benefits may vary by
      state and product. These policies have some limitations and exclusions.
    </div>
    <!-- <v-layout align-content-center justify-center>
      <div
        :style="'margin-top:30px;padding:20px;background: #00558c; min-height:100px; width: '+bannerWidth+'px;'"
      >
        <span style="color:white">
          Contact us at
          <a
            href="mailto:ESD_SofNM@globe.life"
            style="color:white;text-decoration:none;"
          >ESD_SofNM@globe.life</a> to learn more.
          <br />
          <br />
          <a @click="showVideo" style="color:white;">CLICK HERE for a product presentation</a>
        </span>
      </div>
    </v-layout>-->
  </div>
</template>

<script>
export default {
  name: 'home',
  props: { mainColor: String, entity: Object },
  components: {},
  data: () => ({
    myBannerWidth: window.innerWidth - 50,
  }),
  created() {
    window.addEventListener('resize', this.getWindowWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth)
  },
  computed: {
    msg: function () {
      return this.entity.name
    },
    bannerWidth: function () {
      return this.myBannerWidth
    },
  },
  methods: {
    getWindowWidth() {
      this.myBannerWidth = window.innerWidth - 50
    },
    showVideo() {
      let width = window.innerWidth - 200
      window.open(
        './ProductPresentation.mp4',
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,left=100,width=' +
          width +
          ',height=1000'
      )
    },
  },
}
</script>

<style scoped>
.home {
  padding-top: 100px;
}
.welcome {
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-weight: bold;
  font-size: 34px;
}
.welcomeText {
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-size: 18px;
}

.ieFlex {
  display: -ms-flexbox;
  /* -ms-flex-pack: center; */
  /* -ms-flex-align: center; */
  flex-basis: 1;
  /* flex-shrink: 1; */
  flex: 1 1 auto;
}
.wrapper {
  display: flex;
}
.wrapper-inner {
  flex-basis: 100%;
}
.addPadding {
  padding-left: 15px;
  padding-right: 15px;
}
</style>